<template>
  <q-card flat>
    <q-card-section class="q-pa-sm">
      <div class="row q-gutter-sm q-mb-sm">
        <q-input
          outlined
          class="col-2"
          dense
          v-model="FilterString"
          label="套餐名称"
          color="primary"
        />
        <q-btn
          color="primary"
          icon="search"
          @click="onLoadData"
          :loading="PdmBodycheckTaocanListLoading"
          style="height: 38px;"
        >
          查询
        </q-btn>
        <q-space />
        <!-- <q-btn color="primary" icon="download" style="height: 38px;" @click="onDownload" :loading="WxHomeimageListLoading">
              下载
            </q-btn>
            <q-btn color="primary" style="height: 38px" icon="fas fa-file-excel" :loading="PdmBodycheckTaocanListLoading" @click="onExportData">导出</q-btn> -->
        <q-btn
          color="primary"
          style="height: 38px"
          icon="note_add"
          :loading="PdmBodycheckTaocanListLoading"
          @click="onAdd"
          >导入套餐</q-btn
        >
      </div>
      <vxe-grid
        v-bind="gridOptions"
        :sort-config="{ multiple: true }"
        :custom-config="{ storage: true }"
        id="custom-config"
        :export-config="gridOptions.tableExport"
        :height="$store.getters.maxPageHeight - 140"
        :loading="PdmBodycheckTaocanListLoading"
        highlight-current-row
        size="mini"
      >
        <template #toolbar_buttons id="custom-config"> </template>
        <template #IsDelName="{ row }">
          <q-badge :color="row.IsDel == 0 ? 'positive' : 'negative'">
            {{ row.IsDelName }}
          </q-badge>
        </template>
        <template #operate="{ row }">
          <vxe-button
            flat
            color="primary"
            icon="fas  fa-edit"
            @click="onEdit(row)"
            >编辑</vxe-button
          >
          <vxe-button
            flat
            color="negative"
            icon="fas fa-trash"
            @click="onDelete(row)"
            >删除</vxe-button
          >
          <vxe-button flat color="negative" @click="onIsDel(row)">{{
            row.IsDel == 1 ? "上架" : "下架"
          }}</vxe-button>
        </template>
      </vxe-grid>
      <vxe-pager
        perfect
        size="mini"
        :page-sizes="tablePage.pageSizes"
        v-model:current-page="tablePage.currentPage"
        v-model:page-size="tablePage.pageSize"
        :total="tablePage.totalResult"
        :layouts="[
          'PrevPage',
          'JumpNumber',
          'NextPage',
          'FullJump',
          'Sizes',
          'Total',
        ]"
        @page-change="handlePageChange"
      >
      </vxe-pager>
    </q-card-section>
  </q-card>

  <q-dialog v-model="pdmBodycheckTaocanshowDlg" persistent>
    <BodycheckTaocan @onLoadData="onLoadData" />
  </q-dialog>
  <q-dialog v-model="pdmBodycheckTaocanshowDlg2" persistent>
    <BodycheckTaocanEdit @onLoadData="onLoadData" />
  </q-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import XEUtils from "xe-utils";
import dlg from "@/config/dialog";
import BodycheckTaocan from "./bodycheckTaocan.vue";
import BodycheckTaocanEdit from "./bodycheckTaocanEdit.vue";
import * as BodycheckTaocanJS from "@/api/pdm/bodycheckTaocan";
export default {
  components: {
    BodycheckTaocan,
    BodycheckTaocanEdit,
  },
  computed: {
    ...mapState("webConfig", ["WebConfigState"]),
    ...mapState("PdmBodycheckTaocan", [
      "PdmBodycheckTaocanList",
      "PdmBodycheckTaocanListLoading",
      "PdmBodycheckTaocanEntity",
      "PdmBodycheckTaocanShowDlg",
      "PdmBodycheckTaocanShowDlg2",
    ]),

    pdmBodycheckTaocanshowDlg: {
      get() {
        return this.PdmBodycheckTaocanShowDlg;
      },
      set(val) {
        console.log(val);
        this.$store.commit(
          "PdmBodycheckTaocan/setPdmBodycheckTaocanShowDlg",
          val
        );
      },
    },
    pdmBodycheckTaocanshowDlg2: {
      get() {
        return this.PdmBodycheckTaocanShowDlg2;
      },
      set(val) {
        console.log(val);
        this.$store.commit(
          "PdmBodycheckTaocan/setPdmBodycheckTaocanShowDlg2",
          val
        );
      },
    },
  },
  watch: {
    WebConfigState(val) {
      if (val == 1) {
        this.onLoadData();
        this.$store.commit("webConfig/setWebConfigState", 0);
      }
    },
  },
  data() {
    return {
      FilterString: "",
      tablePage: {
        currentPage: 1,
        pageSize: 20,
        totalResult: 0,
        pageSizes: [15, 20, 50, 100, 5000],
      },
      gridOptions: {
        border: true,
        resizable: true,
        showOverflow: true,
        highlightHoverRow: true,
        align: "left",
        toolbarConfig: {
          perfect: true,
          print: true,
          zoom: true,
          custom: true,
          export: true,
          slots: {
            // 自定义工具栏模板
            buttons: "toolbar_buttons",
          },
        },
        //点击编辑必须配置
        // editConfig: {
        //   trigger: "click",
        //   mode: "cell",
        //   activeMethod: () => {
        //     if (this.lockData) return false;
        //     return true;
        //   },
        // },
        tableExport: {},
        columns: [
          { type: "seq", width: 50, align: "center" },
          {
            field: "TaoCan_Code",
            title: "套餐编码",
            sortable: true,
            align: "left",
            width: 100,
          },
          {
            field: "TaoCan_Name",
            title: "套餐名称",
            sortable: true,
            align: "left",
            width: 200,
          },
          {
            field: "Amount",
            title: "套餐原价金额",
            sortable: true,
            align: "right",
            width: 120,
          },
          {
            field: "SaleAmount",
            title: "套餐折扣金额",
            sortable: true,
            align: "right",
            width: 120,
          },
          {
            field: "IsDelName",
            title: "上架/下架",
            sortable: true,
            slots: { default: "IsDelName" },
            align: "center",
            width: 100,
          },
          {
            field: "TaoCan_Sort",
            title: "排序",
            sortable: true,
            align: "left",
            width: 80,
          },
          {
            title: "操作",
            width: 240,
            slots: { default: "operate" },
            align: "center",
            fixed: "right",
          },
          //   {
          //     field: "CatName",
          //     title: "类别",
          //     sortable: true,
          //     editRender: { name: "input" },//点击编辑必须配置
          //     slots: { edit: "CatName" },//点击编辑必须配置
          //     align: "left",
          //     width: 140,
          //   },
        ],
        // data: this.PdmBodycheckTaocanList,
        data: null,
      },
    };
  },
  mounted() {
    this.onLoadData();
  },
  methods: {
    ...mapActions("PdmBodycheckTaocan", [
      "actGetPdmBodycheckTaocanListByPage",
      "actCreatePdmBodycheckTaocan",
      "actEditPdmBodycheckTaocanData",
      "actEditPdmBodycheckTaocan",
      "actDeletePdmBodycheckTaocan",
    ]),
    onLoadData() {
      this.actGetPdmBodycheckTaocanListByPage({
        HospID: this.$store.getters["appUser/hospID"],
        CUser: this.$store.getters["appUser/userID"],
        FilterString: this.FilterString,
        PageIndex: this.tablePage.currentPage,
        pageSize: this.tablePage.pageSize,
      })
        .then((res) => {
          this.gridOptions.data = res.Data;
          this.tablePage.totalResult = res.Count;
        })
        .finally(() => {
          this.$store.commit(
            "PdmBodycheckTaocan/setPdmBodycheckTaocanListLoading",
            false
          );
          //this.PdmBodycheckTaocanListLoading = false;
        });
    },
    onAdd() {
      this.$store.commit(
        "PdmBodycheckTaocan/setPdmBodycheckTaocanShowDlg",
        true
      );
      // this.actCreatePdmBodycheckTaocan({
      //     HospID: this.$store.getters["appUser/hospID"],
      //     CUser: this.$store.getters["appUser/userID"],
      // });
    },
    onEdit(e) {
      var obj = {};
      Object.assign(obj, e);
      this.actEditPdmBodycheckTaocan(obj);
    },
    onDelete(e) {
      this.actDeletePdmBodycheckTaocan({
        HospID: this.$store.getters["appUser/hospID"],
        CUser: this.$store.getters["appUser/userID"],
        Info: e,
      }).then((res) => {
        if (res.Code == 0) {
          this.onLoadData();
        }
      });
    },
    onIsDel(row) {
      BodycheckTaocanJS.UpateIsDel({
        HospID: this.$store.getters["appUser/hospID"],
        CUser: this.$store.getters["appUser/userID"],
        Info: row,
      }).then((res) => {
        if (res.Code == 0) {
          this.onLoadData();
          this.msg.success(res.Message);
        } else {
          dlg.alert(res.Message);
        }
      });
    },
    //onExportData:{},
    //需要合计：表头必须添加 :footer-method="footerMethod" 跟 show-footer
    footerMethod({ columns, data }) {
      var list = ["PRIC"]; //需要汇总的字段
      const footerData = [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (list.includes(column.property)) {
            return XEUtils.sum(data, column.property);
          }
          return null;
        }),
      ];
      return footerData;
    },
    handlePageChange({ currentPage, pageSize }) {
      this.tablePage.currentPage = currentPage;
      this.tablePage.pageSize = pageSize;
      this.onLoadData();
    },
  },
};
</script>
